import Backbone from 'backbone';
import _ from 'underscore';
import Poll from './Poll';

var PollCollection = Backbone.Collection.extend({
    model: Poll,

    url: function() {
        return `/api/v2/polls/event/${this.eventId}/polls/`;
    },

    initialize: function(options) {
        this.eventId = options.eventId;
    },

    parse: function(response) {
        this.fetched = true;
        return response || [];
    },

    setPartners: function(partners) {
        this.each(function(poll) {
            const partnerId = poll.get('partnerId');
            const partner = partners.get(partnerId);
            if (partner) {
                poll.set('partner', partner);
            }
        });
    }

});

export default PollCollection;

